// import React, { useEffect, useRef, useState } from "react";

// const Lmsabout = () => {
//   const imageRef = useRef(null);
//   const textRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(true);
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );

//     if (imageRef.current) observer.observe(imageRef.current);
//     if (textRef.current) observer.observe(textRef.current);

//     return () => {
//       if (imageRef.current) observer.unobserve(imageRef.current);
//       if (textRef.current) observer.unobserve(textRef.current);
//     };
//   }, []);

//   return (
//     <div className="industrial-container">
//       <style>
//         {`
//           .industrial-container {
//             display: flex;
//             flex-direction: row;
//             justify-content: space-between;
//             align-items: center;
//             padding: 40px 5%;
//             background-color: white;
//             flex-wrap: wrap;
//           }
//           .industrial-text {
//             width: 50%;
//             padding-left: 40px;
//             text-align: left;
//           }
//           .industrial-title {
//             font-size: 32px;
//             font-weight: bold;
//             margin-bottom: 20px;
//             color: black;
//             letter-spacing:0px;
//           }
//           .industrial-desc {
//             font-size: 16px;
//             line-height: 1.6;
//             margin-bottom: 15px;
//             text-align: justify;
//             color: black;
//           }
//           .industrial-image-section {
//             width: 45%;
//             text-align: center;
//           }
//           .industrial-image {
//             width: 100%;
//             max-width: 700px;
//             height: auto;
//             border-radius: 8px;
//           }

//           /* Animation styles */
//           .slide-in-left {
//             opacity: 0;
//             transform: translateX(-50px);
//             transition: all 1s ease-in-out;
//           }
//           .slide-in-right {
//             opacity: 0;
//             transform: translateX(50px);
//             transition: all 1s ease-in-out;
//           }
//           .visible {
//             opacity: 1;
//             transform: translateX(0);
//           }

//           /* Responsive */
//           @media (max-width: 1024px) {
//             .industrial-title {
//               font-size: 28px;
//             }
//             .industrial-desc {
//               font-size: 15px;
//             }
//           }
//           @media (max-width: 768px) {
//             .industrial-container {
//               flex-direction: column;
//               padding: 20px;
//             }
//             .industrial-text {
//               width: 100%;
//               padding-left: 0;
//               order: 2;
//             }
//             .industrial-image-section {
//               width: 100%;
//               order: 1;
//               margin-bottom: 30px;
//             }
//             .industrial-title {
//               font-size: 26px;
//               text-align: center;
//             }
//             .industrial-desc {
//               font-size: 14px;
//               text-align: left;
//             }
//           }
//           @media (max-width: 480px) {
//             .industrial-title {
//               font-size: 22px;
//             }
//             .industrial-desc {
//               font-size: 13px;
//             }
//           }
//         `}
//       </style>

//       {/* Image Section */}
//       <div
//         ref={imageRef}
//         className={`industrial-image-section slide-in-left ${
//           isVisible ? "visible" : ""
//         }`}
//       >
//         <img
//           src="/image/lmsabout.png"
//           alt="Industrial Automation"
//           className="industrial-image"
//         />
//       </div>

//       {/* Text Section */}
//       <div
//         ref={textRef}
//         className={`industrial-text slide-in-right ${
//           isVisible ? "visible" : ""
//         }`}
//       >
//        <h2 className="industrial-title">
//    Innovators in Learning Management System (LMS) & Training Automation Platform
// </h2>
// <p className="industrial-desc">
// For companies delivering complex, high-risk projects, the Skills Assurance Platform enables Workforce Competence and associated Project Compliance. Modules and workflows are customizable to meet unique regulatory and organization requirements.
// </p>
// <p className="industrial-desc">
// The Platform integrates with all major Enterprise Resource Planning (ERP) and Human Resource Information Systems (HRIS). As a result, it becomes an integral part our client’s core data environment.
// </p>
// <p className="industrial-desc">
// The learning management system comes with a library of eLearning courses available on the day the application goes live!
// </p>

//       </div>
//     </div>
//   );
// };

// export default Lmsabout;




import React, { useEffect, useRef, useState } from "react";

const Lmsabout = () => {
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (imageRef.current) observer.observe(imageRef.current);
    if (textRef.current) observer.observe(textRef.current);

    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);

  return (
    <div className="lms-about-outer-container">
      <div className="lms-about-container">
        <style>
          {`
            .lms-about-outer-container {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 2rem 1rem;
              background-color: #f5f7fa;
            }
            
            .lms-about-container {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              max-width: 1200px;
              width: 100%;
              background-color: white;
              border-radius: 12px;
              overflow: hidden;
              box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
              padding: 2.5rem;
            }
            
            .lms-about-text {
              width: 48%;
              text-align: left;
            }
            
            .lms-about-title {
              font-size: 2rem;
              font-weight: 700;
              margin-bottom: 1.5rem;
              color: #025261;
              line-height: 1.2;
              letter-spacing:0px;
            }
            
            .lms-about-desc {
              font-size: 1rem;
              line-height: 1.6;
              margin-bottom: 1.2rem;
              color: black;
              text-align:justify;
            }
            
            .lms-about-image-section {
              width: 48%;
              text-align: center;
            }
            
            .lms-about-image {
              width: 100%;
              max-width: 550px;
              height: auto;
              border-radius: 8px;
              // box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            }

            /* Animation styles */
            .slide-in-left {
              opacity: 0;
              transform: translateX(-40px);
              transition: all 0.8s ease-in-out;
            }
            
            .slide-in-right {
              opacity: 0;
              transform: translateX(40px);
              transition: all 0.8s ease-in-out;
            }
            
            .visible {
              opacity: 1;
              transform: translateX(0);
            }

            /* Responsive */
            @media (max-width: 1024px) {
              .lms-about-container {
                padding: 2rem;
              }
              
              .lms-about-title {
                font-size: 1.75rem;
              }
              
              .lms-about-desc {
                font-size: 0.95rem;
              }
            }
            
            @media (max-width: 900px) {
              .lms-about-container {
                flex-direction: column;
                padding: 1.5rem;
              }
              
              .lms-about-text {
                width: 100%;
                order: 2;
                margin-top: 1.5rem;
              }
              
              .lms-about-image-section {
                width: 100%;
                order: 1;
              }
              
              .lms-about-title {
                text-align: center;
                font-size: 1.7rem;
              }
            }
            
            @media (max-width: 600px) {
              .lms-about-outer-container {
                padding: 1.5rem 0.8rem;
              }
              
              .lms-about-container {
                padding: 1.5rem;
                border-radius: 10px;
              }
              
              .lms-about-title {
                font-size: 1.5rem;
                margin-bottom: 1.2rem;
              }
              
              .lms-about-desc {
                font-size: 0.9rem;
                margin-bottom: 1rem;
              }
            }
            
            @media (max-width: 480px) {
              .lms-about-container {
                padding: 1.2rem;
              }
              
              .lms-about-title {
                font-size: 1.4rem;
              }
              
              .lms-about-desc {
                font-size: 0.85rem;
              }
            }
          `}
        </style>

        {/* Image Section */}
        <div
          ref={imageRef}
          className={`lms-about-image-section slide-in-left ${
            isVisible ? "visible" : ""
          }`}
        >
          <img
            src="/image/lmsabout.png"
            alt="Learning Management System"
            className="lms-about-image"
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/550x400/025261/ffffff?text=LMS+Platform";
            }}
          />
        </div>

        {/* Text Section */}
        <div
          ref={textRef}
          className={`lms-about-text slide-in-right ${
            isVisible ? "visible" : ""
          }`}
        >
          <h2 className="lms-about-title">
            Innovators in Learning Management System (LMS) & Training Automation Platform
          </h2>
          <p className="lms-about-desc">
            For companies delivering complex, high-risk projects, the Skills Assurance Platform enables Workforce Competence and associated Project Compliance. Modules and workflows are customizable to meet unique regulatory and organization requirements.
          </p>
          <p className="lms-about-desc">
            The Platform integrates with all major Enterprise Resource Planning (ERP) and Human Resource Information Systems (HRIS). As a result, it becomes an integral part our client's core data environment.
          </p>
          <p className="lms-about-desc">
            The learning management system comes with a library of eLearning courses available on the day the application goes live!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Lmsabout;